import * as React from "react";
import * as S from "@styled";
import styled from "styled-components";
import { ThemeType } from "shared/styles/theme";
import { HashMap } from "shared/model/HashMap";
import colors from "shared/styles/colors";

const StyledCustomColorSwitch = styled.button<{ $backGroundColor: string, $borderColor: string }>`
    height: 40px;
    width: 40px;
    border-radius: 50%;
    margin-right: 10px;
    color: ${props => props.$borderColor};
    background-color: ${props => props.$backGroundColor};
    border: 2px solid ${props => props.$borderColor};
    font-size: 1.375rem;

    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`

const CustomColorSwitcher: React.FC<ICustomColorSwitcherProps> = (props) => {
    return (
        <S.FlexContainer className="custom-color-switcher-selector">
            {props.colors.map((colorButton, i) => (
                <StyledCustomColorSwitch
                    key={i}
                    $backGroundColor={colorButton.backgroundColor}
                    $borderColor={colorButton.borderColor}
                    onClick={colorButton.onClick}
                >
                    {colorButton.selected && (
                        colorButton.asDisabled ? <DisabledLine $color={colorButton.borderColor} /> : <i className="ci-check_big" />
                    )}
                </StyledCustomColorSwitch>
            ))}
        </S.FlexContainer>
    )
}

const widgetColorMap: HashMap<ICustomColorConfigurationMap> = {
    [ThemeType.light]: {
        "purple": {
            backgroundColor: colors.purpleBackground,
            borderColor: colors.purplePrimary,
            color: colors.purplePrimary
        },
        "blue": {
            backgroundColor: colors.blueBackground,
            borderColor: colors.bluePrimary,
            color: colors.blueDark
        },
        "green": {
            backgroundColor: colors.greenBackground,
            borderColor: colors.greenPrimary,
            color: colors.greenDark
        },
        "grey": {
            backgroundColor: colors.grey_4,
            borderColor: colors.grey_1,
            color: colors.grey_1
        },
        "orange": {
            backgroundColor: colors.orangeBackground,
            borderColor: colors.orangePrimary,
            color: colors.orangeDark
        },
        "pink": {
            backgroundColor: colors.pinkBackground,
            borderColor: colors.pinkPrimary,
            color: colors.pinkDark
        }
    },
    [ThemeType.dark]: {
        "purple": {
            backgroundColor: colors.darkPurpleTagBackground,
            borderColor: colors.darkPurpleTagBorder,
            color: colors.grey_5
        },
        "blue": {
            backgroundColor: colors.darkBlueBackground,
            borderColor: colors.darkBluePrimary,
            color: colors.grey_5
        },
        "green": {
            backgroundColor: colors.darkGreenBackground,
            borderColor: colors.darkGreenPrimary,
            color: colors.grey_5
        },
        "grey": {
            backgroundColor: colors.grey_1,
            borderColor: colors.grey_2,
            color: colors.grey_5
        },
        "orange": {
            backgroundColor: colors.darkOrangeBackground,
            borderColor: colors.darkOrangePrimary,
            color: colors.grey_5
        },
        "pink": {
            backgroundColor: colors.darkWarningBackground,
            borderColor: colors.darkWarningPrimary,
            color: colors.grey_5
        }
    }
};

const DisabledLine = styled.div<{ $color: string }>`
    position: absolute;
    width: 2.5rem;
    height: 2px;
    rotate: 45deg;
    background-color: ${props => props.$color};
`

export const getSwitchColorByTheme = (theme: ThemeType, color: ICustomWidgetColor): ICustomColorConfiguration => {
    return widgetColorMap[theme][color];
}
export interface ICustomColorConfiguration {
    backgroundColor: string;
    borderColor: string;
    color: string;
    asDisabled?: boolean;
}

export type ICustomWidgetColor = "purple" | "orange" | "pink" | "blue" | "green" | "grey";

export type ICustomColorConfigurationMap = {
    [color in ICustomWidgetColor]: ICustomColorConfiguration;
}

export interface ICustomColorSwitch extends ICustomColorConfiguration {
    selected?: boolean;
    onClick: () => void;
}

interface ICustomColorSwitcherProps {
    colors: ICustomColorSwitch[];
}

export default CustomColorSwitcher;